import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { SharedDataService } from 'elbuild-ui-lib-core';
import { environment } from 'src/environments/environment';
import { Customer } from 'yf-commerce-model-ui-lib';

@Component({
	selector: 'app-my-account-login',
	templateUrl: './my-account-login.component.html',
	styleUrl: './my-account-login.component.scss',
	standalone: false
})
export class MyAccountLoginComponent implements OnDestroy {

	forgotPwdUrl: string = environment.baseURL + environment.forgotpasswordredirecturl;
	signupUrl: string = environment.baseURL + environment.registerRedirectUrl;
	loggedUser: Customer;
	usersub: any;



	constructor(private sharedDataService: SharedDataService, private router: Router) {
		this.usersub = this.sharedDataService.currentLoggedUser.subscribe(data => {
			this.loggedUser = data as unknown as Customer;
			if (this.loggedUser) {

				this.router.navigateByUrl('/');
			}
		});


	}
	ngOnDestroy(): void {

		if (this.usersub) {
			this.usersub.unsubscribe();
		}
	}
}
